module.exports = __webpack_public_path__ + "img/IMAGINE_DRAGONS_20s.57f77094.jpg";